import { render } from "./login.html?vue&type=template&id=63c04ae6&scoped=true&ts=true"
import script from "./login.ts?vue&type=script&lang=ts"
export * from "./login.ts?vue&type=script&lang=ts"

import "./login.scss?vue&type=style&index=0&id=63c04ae6&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c04ae6"]])

export default __exports__